module.exports = __webpack_public_path__ + "img/ic-delete.35779446.svg";